import styled from "styled-components";

export const LikeTrackBtn = styled.button`
  display: flex;
  width: 48px;
  height: 48px;
  justify-content: center;
  align-items: center;
  transition: all 0.1s ease-out;
  padding: 0px;
  border-radius: 12px;
  z-index: 1;
  background-color: ${({ withBgColor }) =>
    withBgColor ? "#363636" : "inherit"};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      transform: scale(1.25);
    }
  }

  &:active {
    transform: scale(1);
  }

  path {
    transition: fill 0.1s ease-out;
    fill: ${({ like }) => (like ? "var(--orange-primary)" : "white")};
  }
`;
